// src/boot/number-format.js
export const toEnglishDigits = (str = '') => {
  const fa = '۰۱۲۳۴۵۶۷۸۹'
  const ar = '٠١٢٣٤٥٦٧٨٩'
  return String(str)
    .replace(/[۰-۹]/g, d => fa.indexOf(d))
    .replace(/[٠-٩]/g, d => ar.indexOf(d))
}

export const normalizeNzAccount = (input = '', { slice = false } = {}) => {
  const raw = toEnglishDigits(input).replace(/\D+/g, '')
  return slice ? raw.slice(0, 16) : raw
}

const groupedStrictRe = /^(\d{2})([-\s])(\d{4})\2(\d{7})\2(\d{2,3})$/

export const validateNzAccount = (input = '') => {
  const s = toEnglishDigits(String(input)).trim()
  if (/[^0-9-\s]/.test(s)) return { valid: false, reason: 'invalid_chars' }

  if (/[-\s]/.test(s)) {
    const ok = groupedStrictRe.test(s)
    return ok
      ? { valid: true, raw: s.replace(/[-\s]/g, '') }
      : { valid: false, reason: 'grouping' }
  }

  if (!/^\d{15,16}$/.test(s)) return { valid: false, reason: 'length' }
  return { valid: true, raw: s }
}

export const getRawNzAccountOrNull = (input = '') => {
  const v = validateNzAccount(input)
  return v.valid ? v.raw : null
}

export default ({ Vue }) => {
  // eslint-disable-next-line no-extend-native
  Number.prototype.toFixedDown = function (digits) {
    const re = new RegExp('(\\d+\\.\\d{' + digits + '})(\\d)')
    const m = this.toString().match(re)
    return m ? parseFloat(m[1]) : this.valueOf()
  }

  // eslint-disable-next-line no-extend-native
  Number.prototype.roundToX = function (decimal) {
    const x = Math.pow(10, decimal)
    return Math.round(this * x) / x
  }

  // eslint-disable-next-line no-extend-native
  Number.prototype.fixZero = function () {
    const value = Math.abs(this)
    return value < 0.00001 ? 0 : value
  }

  // eslint-disable-next-line no-extend-native
  String.prototype.commaSeparate = function () {
    return this.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  // eslint-disable-next-line no-extend-native
  String.prototype.purify = function () {
    return this.replace(/-|\s/g, '')
  }

  Vue.prototype.$nzAccount = {
    toEnglishDigits,
    normalize: normalizeNzAccount,
    validate: validateNzAccount,
    getRaw: getRawNzAccountOrNull,
    groupedStrictRe
  }
}
